/**
 * Clone Int64 value
 *
 * @param {import('./Int64Type.js').BrandedInt64} value - Value to clone
 * @returns {import('./Int64Type.js').BrandedInt64} Cloned value
 */
export function clone(value) {
	return /** @type {import('./Int64Type.js').BrandedInt64} */ (value);
}
